import { render, staticRenderFns } from "./commonAside.vue?vue&type=template&id=03bf5cbc&scoped=true&"
import script from "./commonAside.vue?vue&type=script&lang=js&"
export * from "./commonAside.vue?vue&type=script&lang=js&"
import style0 from "./commonAside.vue?vue&type=style&index=0&id=03bf5cbc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf5cbc",
  null
  
)

export default component.exports